module.exports = __webpack_public_path__ + "img/meme_12.01aab31b.jpg";